import CommentDialog from './CommentDialog';

export default CommentDialog;
